import React, { useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import AddTask from "./components/AddTask";
import Tasks from "./components/tasks";
import Header from "./components/header";
import TaskDetails from "./components/TaskDetails";
import { v4 as uuidv4 } from "uuid";

const App = () => {
  const history = useNavigate();

  const [ShowDetails, setShowDetails] = useState("");

  const [tasks, setTask] = useState([
    {
      id: "1",
      title: "Estudar programação",
      status: false,
      details: "Continuar meus estudo em ReactJs e NodeJs",
    },
    {
      id: "2",
      title: "Fazer o Almoço",
      status: false,
      details: "Strogonoff de frango e Pudim de Sobremesa",
    },
    {
      id: "3",
      title: "Trabalhar no campo",
      status: false,
      details: "Fazer no minimo 1 hora",
    },
  ]);

  const handleTaskClick = (taskId) => {
    const newTasks = tasks.map((task) => {
      if (task.id === taskId) return { ...task, status: !task.status };

      return task;
    });

    setTask(newTasks);
  };

  const handleTaskAdd = (tasktitle) => {
    const newTask = [
      ...tasks,
      {
        title: tasktitle,
        id: uuidv4(),
        status: false,
        details: "",
      },
    ];

    setTask(newTask);
  };

  const Removetask = (taskId) => {
    const newTasks = tasks.filter((task) => task.id !== taskId);
    setTask(newTasks);
  };

  const HandleClickTaskDetails = (taskID) => {
    const details = tasks.filter((task) => task.id === taskID);
    setShowDetails(details[0].details);
  };

  const HandleDetailsChange = (newDetails, taskID) => {
    tasks.forEach((task) => {
      if (task.id === taskID) {
        return (task.details = newDetails);
      }
      return task;
    });

    history("/TaskList");

  };


  return (
    <div className="container">
      <Header />
      <Routes>
        <Route
          path="/TaskList"
          exact
          element={
            <>
              <AddTask handleTaskAdd={handleTaskAdd} />
              <Tasks
                tasks={tasks}
                handleTaskClick={handleTaskClick}
                Removetask={Removetask}
                HandleClickTaskDetails={HandleClickTaskDetails}
              />
            </>
          }
        />
        <Route
          exact
          path="/TaskList/:taskTitle"
          element={
            <TaskDetails
              Details={ShowDetails}
              HandleDetailsChange={HandleDetailsChange}
              tasks={tasks}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default App;
